import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor() {

    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        if(request.url == environment.URL){
          request = request.clone({
            setHeaders: {
                'x-api-key': environment.API_LEX,
            },
          });
        }else if(request.url == environment.LAMBDA_FUNCTION_URL){
          request = request.clone({
            setHeaders: {
              'Access-Control-Allow-Origin':'*',
              'Access-Control-Allow-Headers':'Content-Type',
              'Access-Control-Allow-Methods':'POST'
            },
          });
        }
        // const isApiUrl = request.url.startsWith(environment.URL);
        // request = request.clone({
        //         setHeaders: {
        //             Authorization: `Bearer ${token}`,
        //         },
        //     });



        return next.handle(request);
    }
}
